import { getWindow } from '../window/window';
import * as numeral from 'numeral';

/**
 * Return numeral library associated to the global native browser window obj
 * @returns { numeral }
 * @private
 */
export function getNumeral(): any {

    const w: any = getWindow();
    if (!w.numeral) {
        w['numeral'] = numeral;
    }
    return w.numeral;
}
